// IMPORTANT: This import MUST be first to disable error overlay before React loads
import './disableErrorOverlay';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/common-styles.css'; // Global styles - imported once
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Globally prevent ArrowUp/ArrowDown from incrementing/decrementing number inputs.
// Using capture phase so it intercepts before React's synthetic event system.
document.addEventListener(
  'keydown',
  (e: KeyboardEvent) => {
    const target = e.target as HTMLElement;
    if (
      target.tagName === 'INPUT' &&
      (target as HTMLInputElement).type === 'number' &&
      (e.key === 'ArrowUp' || e.key === 'ArrowDown')
    ) {
      e.preventDefault();
    }
  },
  { capture: true }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
